import { ActionContext } from 'vuex';

export type CategorySeenDates = { [key: string]: number };

///
// State

export type State = {
    categorySeenState: null | CategorySeenDates,
}

///
// Mutations

export enum MutationTypes {
    LOAD_STATE = 'LOAD_STATE',
    SET_CATEGORY_SEEN = 'SET_CATEGORY_SEEN',
}

type MutationsWithParameter<S = State> = {
    [MutationTypes.LOAD_STATE](state: S, payload: { categorySeenState: CategorySeenDates }): void
    [MutationTypes.SET_CATEGORY_SEEN](state: S, payload: { category: string }): void
}
export type Mutations<S = State> = MutationsWithParameter;

///
// Actions

export type AugmentedActionContext = {
    commit<K extends keyof MutationsWithParameter>(
        key: K,
        payload: Parameters<MutationsWithParameter[K]>[1]
    ): ReturnType<MutationsWithParameter[K]>
} & Omit<ActionContext<State, State>, 'commit'>

export interface Actions {
    loadState ({ commit }: AugmentedActionContext): void
    setCategorySeenDate ({ commit }: AugmentedActionContext, { category: string }): void
}

///
// Getters

export interface Getters {
    categoryLastSeenDates(state: State): CategorySeenDates;
}
